import {
  ETransportType,
  EUndergroundType,
  INewbuildingPromo,
  NewbuildingPromoCarousel,
} from '@cian/frontend-newbuilding-promo-carousel-component';
import * as React from 'react';

import * as styles from './Newobjects.css';
import { ISimilarNewobject } from '../../../types/similarNewobjects';

export interface INewobjectsProps {
  similarNewobjects: ISimilarNewobject[] | null;
  fromDeveloper?: boolean;
}

const SLIDES_PER_SCREEN = 5;
const BORDER_COLOR = 'var(--stroke-control-default)';

const noop = () => {};

export const Newobjects: React.FC<INewobjectsProps> = ({ similarNewobjects, fromDeveloper }) => {
  const fetchNewbuildings = React.useCallback(
    async (): Promise<INewbuildingPromo[]> =>
      (similarNewobjects ?? []).map(item => {
        const undergroundInfo = item.undergroundInfo;

        return {
          ...item,
          isLoaded: true,
          undergroundInfo: undergroundInfo
            ? {
                ...undergroundInfo,
                transportType: undergroundInfo.transportType as ETransportType,
                undergroundType: undergroundInfo.undergroundType as EUndergroundType,
              }
            : null,
        };
      }),
    [similarNewobjects],
  );

  const newbuildingIds = React.useMemo(() => (similarNewobjects ?? []).map(item => item.id), [similarNewobjects]);

  if (!similarNewobjects || !similarNewobjects.length) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>{fromDeveloper ? 'ЖК от застройщика' : 'Похожие ЖК'}</div>
        <NewbuildingPromoCarousel
          onNewbuildingClick={noop}
          fetchStep={newbuildingIds.length}
          slidesPerView={SLIDES_PER_SCREEN}
          fetchData={fetchNewbuildings}
          ids={newbuildingIds}
          addressMaxLines={1}
          cardBorderColor={BORDER_COLOR}
        />
      </div>
    </div>
  );
};
